<template>
  <v-container fluid>
    <v-row justify="start">
      <v-btn :ripple="false" @click="$router.push(`/welcome`)" color="primary" text>
        <v-icon>mdi-chevron-left</v-icon>
        {{$t('back_to_homepage')}}
      </v-btn>
    </v-row>
    <v-row justify="center">
      <p class="righteous-heading">{{$t('choose_your_region')}}</p>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-card color="background">
          <v-card-text>
            <p class="primary--text text-center">{{$t('covid_19')}}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="8" v-for="i in auctions" :key="i.id">
        <v-card :to="`/browse-auctions/${i.id}`">
          <v-img
            :src="i.image_url"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,0.1)"
            height="220px"
          >
            <v-row class="justify-center card-title-background">
              <v-card-title class="text-center pa-0">{{i.name}}</v-card-title>
            </v-row>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <app-footer text-color="primary--text" class="mt-11" />
    </v-row>
  </v-container>
</template>

<script>
import { AUCTIONS_API } from '@/clients/auctions.api'
import { mapGetters } from 'vuex'
export default {
  components: {
    AppFooter: () => import('@/components/Footer.vue')
  },
  async mounted () {
    await this.getAuctions()
    if (this.vg_lang === 'fr') {
      this.translateToFrench()
    }
  },
  data () {
    return {
      auctions: []
    }
  },
  methods: {
    async getAuctions () {
      this.$spinner()
      let res
      try {
        res = await AUCTIONS_API.Auctions.getAllAuctions()
      } catch (error) {
        console.log(error)
        return this.$spinner()
      }
      console.log(res)
      this.auctions = res.payload.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      this.$spinner()
    },
    async translateToFrench () {
      this.$spinner()
      for (const auc of this.auctions) {
        let res
        try {
          res = await AUCTIONS_API.Localization.getLocalizedData(auc.id, 'auction')
          console.log(res)

          const index = this.auctions.findIndex(i => i.id === res.payload.ref_id)
          if (index > -1) {
            Object.keys(res.payload.response).forEach(i => { this.auctions[index][i] = res.payload.response[i] })
          }
        } catch (error) {
          continue
        }
      }
      this.$spinner()
    }
  },
  computed: {
    ...mapGetters({
      vg_lang: 'Locale/lang'
    })
  },
  watch: {
    vg_lang: {
      handler: async function (x) {
        if (x === 'en') {
          await this.getAuctions()
        } else if (x === 'fr') {
          this.translateToFrench()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-title-background {
  background: rgba(0, 0, 0, 0.3);
}
</style>
